import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  EXERCISE_FEATURE_KEY,
  ExerciseState,
  exerciseAdapter,
} from './exercise.reducer';
import { CallState, LoadingState } from '@lyceo/shared/util-loading';
import { selectParamParagraphExerciseIds } from '../paragraph/paragraph.selectors';
import { isDefined } from '@lyceo/shared/util';

export const selectExerciseState =
  createFeatureSelector<ExerciseState>(EXERCISE_FEATURE_KEY);

const { selectAll } = exerciseAdapter.getSelectors();

export const selectAllExercises = createSelector(
  selectExerciseState,
  (state: ExerciseState) => selectAll(state),
);

export const selectAlfredCallState = createSelector(
  selectExerciseState,
  (state: ExerciseState) => state.alfredCallState,
);

export const selectAlfredLoading = createSelector(
  selectAlfredCallState,
  (callState: CallState) => callState === LoadingState.LOADING,
);

export const selectParamExercises = createSelector(
  selectAllExercises,
  selectParamParagraphExerciseIds,
  (exercises, exerciseIds) =>
    exercises.filter((exercise) => exerciseIds.includes(exercise.id)),
);

export const selectParamExercisesQuestionnaireIds = createSelector(
  selectParamExercises,
  (exercises) =>
    exercises
      .filter((exercise) => isDefined(exercise.questionnaireId))
      .map((exercise) => exercise.questionnaireId),
);
